// @ts-nocheck
import { ColourBands } from '../../../customization/constants.js';

export enum Flags {
    CLIP_MODE = 1,
    HIGHLIGHTED = 2,
    ISOLATED = 4,
}

export const highlightMixin = {
    initHighlight(maxClipBoxes = 100) {
        if (this._highlightInitialized) {
            return;
        }

        this._clipBoxFlagsArray = new Int32Array(maxClipBoxes).fill(0);
        this._clipPolygonFlagsArray = new Int32Array(maxClipBoxes).fill(0);
        this.highlightTint = new THREE.Vector3(1.0, 0.0, 0.0);
        this.isClipVolumeTool = true;
        this.cropBoxes = [];
        this.cropPolygons = [];

        this.originalSetClipBoxes = this.setClipBoxes;
        this.setClipBoxes = (clipBoxes) => {
            for (const i = 0; i < clipBoxes.length; i++) {
                const mode = typeof clipBoxes[i]?.box?.crop === 'undefined' ? true : !clipBoxes[i]?.box?.crop;
                if (clipBoxes[i].box.typeString === 'ProfileClipVolume') {
                    const highlight = clipBoxes[i].box.shouldHighlight;
                    this.setClipBoxFlag(i, {
                        highlight,
                    });
                }
                this.setClipBoxFlag(i, {
                    mode,
                });
            }
            this.originalSetClipBoxes(clipBoxes);
        };

        this.originalSetClipPolygons = this.setClipPolygons;
        this.setClipPolygons = (clipPolygons) => {
            for (const i = 0; i < clipPolygons.length; i++) {
                const mode = typeof clipPolygons[i]?.crop === 'undefined' ? true : !clipPolygons[i]?.crop;
                this.setClipPolygonFlag(i, {
                    mode,
                });
            }
            this.originalSetClipPolygons(clipPolygons);
        };

        Object.defineProperty(this, 'clipBoxFlags', {
            get: () => this._clipBoxFlags,
            set: (val) => {
                this._clipBoxFlags = val;
                if (this.uniforms.clipBoxFlags) {
                    this.uniforms.clipBoxFlags.value = this._clipBoxFlags;
                }
            },
        });

        Object.defineProperty(this, 'clipPolygonFlags', {
            get: () => this._clipPolygonFlags,
            set: (val) => {
                this._clipPolygonFlags = val;
                if (this.uniforms.clipPolygonFlags) {
                    this.uniforms.clipPolygonFlags.value = this._clipPolygonFlags;
                }
            },
        });

        Object.assign(this.uniforms, {
            clipBoxFlags: {
                type: 'iv',
                value: this._clipBoxFlagsArray,
            },
            clipPolygonFlags: {
                type: 'iv',
                value: this._clipPolygonFlagsArray,
            },
            isClipVolumeTool: {
                type: 'b',
                value: this.isClipVolumeTool,
            },
            highlightTint: {
                type: 'v3',
                value: this.highlightTint,
            },
        });

        window.materialTracker.register(this);
        this._highlightInitialized = true;

        this.updateShaderSource();
    },

    setClipBoxFlag(index, flags) {
        if (index < 0) return;

        const packFlag = (packedValue: number, flag: Flags, enabled: boolean) => {
            if (enabled) {
                return packedValue | flag;
            } else {
                return packedValue & ~flag;
            }
        };

        this._clipBoxFlagsArray[index] = packFlag(
            this._clipBoxFlagsArray[index],
            Flags.CLIP_MODE,
            flags.mode ? flags.mode : flags.mode === false ? false : this._clipBoxFlagsArray[index] & Flags.CLIP_MODE
        );
        this._clipBoxFlagsArray[index] = packFlag(
            this._clipBoxFlagsArray[index],
            Flags.HIGHLIGHTED,
            flags.highlight
                ? flags.highlight
                : flags.highlight === false
                ? false
                : this._clipBoxFlagsArray[index] & Flags.HIGHLIGHTED
        );
        this._clipBoxFlagsArray[index] = packFlag(
            this._clipBoxFlagsArray[index],
            Flags.ISOLATED,
            flags.isolate
                ? flags.isolate
                : flags.isolate === false
                ? false
                : this._clipBoxFlagsArray[index] & Flags.ISOLATED
        );

        this.uniforms.clipBoxFlags.needsUpdate = true;
        this.needsUpdate = true;

        this.dispatchEvent({
            type: 'material_property_changed',
            target: this,
        });
    },

    setIsClipVolumeTool(value: boolean) {
        this.isClipVolumeTool = value;
        this.uniforms.isClipVolumeTool.value = this.isClipVolumeTool;
        this.dispatchEvent({
            type: 'material_property_changed',
            target: this,
        });
    },

    setClipPolygonFlag(index, flags) {
        if (index < 0) return;

        const packFlag = (packedValue: number, flag: Flags, enabled: boolean) => {
            if (enabled) {
                return packedValue | flag;
            } else {
                return packedValue & ~flag;
            }
        };

        this._clipPolygonFlagsArray[index] = packFlag(
            this._clipPolygonFlagsArray[index],
            Flags.CLIP_MODE,
            flags.mode
                ? flags.mode
                : flags.mode === false
                ? false
                : this._clipPolygonFlagsArray[index] & Flags.CLIP_MODE
        );
        this._clipPolygonFlagsArray[index] = packFlag(
            this._clipPolygonFlagsArray[index],
            Flags.HIGHLIGHTED,
            flags.highlight
                ? flags.highlight
                : flags.highlight === false
                ? false
                : this._clipPolygonFlagsArray[index] & Flags.HIGHLIGHTED
        );
        this._clipPolygonFlagsArray[index] = packFlag(
            this._clipPolygonFlagsArray[index],
            Flags.ISOLATED,
            flags.isolate
                ? flags.isolate
                : flags.isolate === false
                ? false
                : this._clipPolygonFlagsArray[index] & Flags.ISOLATED
        );

        this.uniforms.clipPolygonFlags.needsUpdate = true;
        this.needsUpdate = true;

        this.dispatchEvent({
            type: 'material_property_changed',
            target: this,
        });
    },

    setIsClipVolumeTool(value: boolean) {
        this.isClipVolumeTool = value;
        this.uniforms.isClipVolumeTool.value = this.isClipVolumeTool;
        this.dispatchEvent({
            type: 'material_property_changed',
            target: this,
        });
    },

    setHighlightTint(r, g, b) {
        this.highlightTint.set(r, g, b);
        this.uniforms.highlightTint.value.copy(this.highlightTint);
        this.dispatchEvent({
            type: 'material_property_changed',
            target: this,
        });
    },
};

export const colourBandMixin = {
    initColourBands() {
        if (this._colourBandsInitialized) {
            return;
        }

        this.deformationStepColours = this.generateRangeUniform<Float32>(ColourBands.Colours, 3);
        this.deformationSteps = this.generateRangeUniform<Float32>(ColourBands.Range_25mm, 2);

        Object.assign(this.uniforms, {
            deformationSteps: {
                type: '2fv',
                value: this.deformationSteps,
            },
            deformationStepColours: {
                type: '3fv',
                value: this.deformationStepColours,
            },
        });

        this._colourBandsInitialized = true;

        this.updateShaderSource();
    },

    setStepColours(colourBands) {
        this.deformationStepColours = colourBands;
        this.uniforms.deformationStepColours.value = this.deformationStepColours;
        this.dispatchEvent({
            type: 'material_property_changed',
            target: this,
        });
    },

    setDeformationSteps(value: string) {
        switch (value) {
            case '25':
            case 25:
                this.deformationSteps = this.generateRangeUniform<Float32>(ColourBands.Range_25mm, 2);
                break;
            case '50':
            case 50:
                this.deformationSteps = this.generateRangeUniform<Float32>(ColourBands.Range_50mm, 2);
                break;
            case '100':
            case 100:
                this.deformationSteps = this.generateRangeUniform<Float32>(ColourBands.Range_100mm, 2);
                break;
            default:
                this.deformationSteps = this.generateRangeUniform<Float32>(ColourBands.Range_25mm, 2);
        }
        this.uniforms.deformationSteps.value = this.deformationSteps;
        this.dispatchEvent({
            type: 'material_property_changed',
            target: this,
        });
    },

    generateRangeUniform<T>(range: Array<T>, size = 2): Array<T> {
        const rangeArray = [];
        for (let i = 0; i < range.length; i += size) {
            const subArray = range.slice(i, i + size);
            rangeArray.push(...subArray);
        }
        return rangeArray;
    },
};
